import React from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import yourchalenge from "../img/challange.png";
import ourservice from "../img/services.png";
import ourapproch from "../img/approach.png";
import benifits from "../img/benifits.png";
import "../css/servicesfont.css";

export default function CredentialingDesc() {
  return (
    <MDBContainer fluid className="p-0 bg-light">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-12 mb-5">
            <div className="card p-2 pb-0" style={{backgroundColor:'#B777FF',opacity:'100%'}}>
            <div className="row pt-4">
              <div class="col-md-2 text-center">
                <img src={yourchalenge} height="200px" with="200" alt="Challange"/>
              </div>
              <div class="col-md-10">
                <h2 className="title fontsizeset2" style={{color:'black',fontFamily:'Alegreya Sans',fontWeight:'bold'}}>Your Credentialing Challenges: A Barrier to Revenue and Compliance</h2>
                <hr style={{ border: "2px Solid #582C83" }}></hr>
                <p 
  className="mt-3 mb-0 justify-content-left"  
  style={{ 
    fontSize: '18px', 
    fontFamily: 'Alegreya Sans', 
    fontWeight: '500', 
    color: 'black', 
    lineHeight: '1.5', 
    marginBottom: '10px' 
  }}
>
  Navigating the provider <b>credentialing</b> and enrollment process is time-consuming, complex, and often frustrating. For most practices, the constant
  back-and-forth with insurance companies—dropped calls, unreturned messages, and unclear status updates—can create significant delays. These delays not only slow down provider onboarding but also lead to serious <b>reimbursement issues</b> and cash flow disruptions.
</p>

<p 
  className="mt-3 mb-0 justify-content-left"  
  style={{ 
    fontSize: '18px', 
    fontFamily: 'Alegreya Sans', 
    fontWeight: '500', 
    color: 'black', 
    lineHeight: '1.5', 
    marginBottom: '10px' 
  }}
>
  Staying compliant with each payer’s requirements demands organization, persistence, and up-to-date knowledge of changing regulations. Without a structured approach, practices risk claim denials, delayed payments, and administrative overload—directly impacting your <b>revenue cycle management.</b>
</p>

<p 
  className="mt-3 mb-0 justify-content-left"  
  style={{ 
    fontSize: '18px', 
    fontFamily: 'Alegreya Sans', 
    fontWeight: '500', 
    color: 'black', 
    lineHeight: '1.5', 
    marginBottom: '10px' 
  }}
>
  For small practices or growing clinics, managing credentialing in-house can quickly become overwhelming. That’s why many providers turn to trusted 
  <a
    href="https://acerhealth.com/blog/outsourcing-medical-billing-questions"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
  >
    medical billing outsourcing
  </a> 
  partners like AcerHealth to streamline credentialing and reduce costly errors. Our team ensures you stay ahead of the paperwork, meet every deadline, and maintain uninterrupted insurance participation.
</p>

              </div>
            </div>
            </div>
          </div>

          <div className="col-lg-12 mb-5">
          <div className="card p-2" style={{backgroundColor:'#BFD200',opacity:'100%'}}>
            <div className="row pt-4">
              <div class="col-md-2 mb-2 mt-4 p-2 text-center ">
                <img src={ourservice} height="200px" with="200" alt="Insurance Verification services"/>
              </div>
              <div class="col-md-10">
                <h2 className="title fontsizeset2" style={{color:'black',fontFamily:'Alegreya Sans',fontWeight:'bold'}}>Our Credentialing Services: Customized for Your Practice</h2>
                <hr style={{ border: "2px Solid #582C83" }}></hr>
                <p className="mt-3 mb-0 justify-content-left" style={{color:'black',fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
               Insurance companies require healthcare providers to regularly update their credentials. If updates are not submitted on time, claims can be denied—leading to delays in payment and disruptions in your 
               <a
    href="https://acerhealth.com/services/revenue-cycle-management"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
  >
    revenue cycle management.
  </a> 
             
                At AcerHealth, we offer flexible, efficient <b>credentialing services </b>tailored to your operational and compliance needs. </p>
                <p className="mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',color:'black' }}>
              AcerHealth streamlines credentialing from start to finish—so your attention remains on delivering quality healthcare. 
              Our credentialing experts ensure your information is accurate, up to date, and accepted by all payers.
                </p>

                <div class="col"  style={{color:'black',fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                 
                   <p><b> Our Credentialing Services Include: </b></p>
                     <ul class="service_list">
                    <ul class="service_list" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                      <li style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>New provider enrollment (all payers / multiple states)</li>
                      <li style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>Commercial insurance credentialing</li>
                      <li style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>Medicaid provider enrollment (including HMOs)</li>
                      <li style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>Professional license renewal</li>
                      <li style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                      <a
                            href="https://pecos.cms.hhs.gov/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
            PECOS 
                        </a>  and I&A updates</li>
                      <li style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>Facility privileging coordination</li>
                      <li style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                        <a
                            href="https://nppes.cms.hhs.gov/webhelp/nppeshelp/MAIN%20PAGE.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              NPI registration (Type I and Type II)
                        </a></li>
                    </ul>
                  
                  </ul>
 <p className="mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',color:'black' }}>
             Our services are designed to complement your 
              <a
                            href="https://acerhealth.com/services/medical-billing-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              medical billing services
                        </a>
             and help prevent credentialing-related payment delays.
                </p>


                </div>
              </div>
            </div>
            </div>
          </div>

          <div className="col-lg-12 mb-5">
          <div className="card p-2" style={{backgroundColor:'#FFA034',opacity:'100%'}}>
            <div className="row pt-4">
              <div class="col-md-2 mb-2 mt-2 p-2 text-center ">
                <img src={ourapproch} height="200px" with="200" alt="Our Approach"/>
              </div>
              <div class="col-md-10">
                <h2 className="title fontsizeset2"  style={{color:'black',fontFamily:'Alegreya Sans',fontWeight:'bold'}}>Our Approach: Proactive and Structured Credentialing Support</h2>
                <hr style={{ border: "2px Solid #582C83" }}></hr>
                <p className=" mb-0 justify-content-left"  style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',color:'black' }}>
              Credentialing lapses often go unnoticed until reimbursement is affected. Many healthcare organizations are unaware when credentials 
              expire or become invalid with payers—creating serious 
               <a
                            href="https://acerhealth.com/services/denial-management-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              healthcare denial management
                        </a> challenges. </p>
               <p className=" mb-0 justify-content-left"  style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',color:'black' }}>
              At  <a
                            href="https://acerhealth.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              AcerHealth,
                        </a>
               we use a systemized, transparent process to ensure your provider credentials are fully verified and kept current.
               
         </p>
        
                <div class="col ml-2"  style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',color:'black' }}>
                   <p><b>Our Credentialing Process Includes:</b> </p>
                  <ul class="approach_list">
                    <li className=" mb-0 justify-content-left" sstyle={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                   Real-time tracking of all provider credential expiration dates
                    </li>
                    <li className=" mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                    	Secure organization and maintenance of all credentialing databases
                    </li>
                    <li className=" mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                   	Direct communication with insurance payers to verify provider effective dates
                    </li>
                    <li className=" mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                      {" "}
                    Confidential handling of all provider and group data
                    </li>
                  </ul>
                   <p className=" mb-0 justify-content-left"  style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',color:'black' }}>
            Our structured approach minimizes risk and supports long-term compliance, aligning with our mission as a trusted   <a
                            href="https://acerhealth.com/services/medical-consultancy-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
             medical consultancy service.
                        </a>
             
         </p>
                </div>
              </div>
            </div>
            </div>
          </div>

          <div className="col-lg-12 mb-5">
          <div className="card p-2" style={{backgroundColor:'#B6CCFE',opacity:'100%'}}>
            <div className="row pt-4">
              <div class="col-md-2 mb-2 mt-4 p-2 text-center ">
                <img src={benifits} height="200px" with="200" alt="Outsourcing Benifits"/>
              </div>
              <div class="col-md-10">
                <h2 className="title fontsizeset2"  style={{color:'black',fontFamily:'Alegreya Sans',fontWeight:'bold'}}>The Benefits of Outsourcing Credentialing to AcerHealth</h2>
                <hr style={{ border: "2px Solid #582C83" }}></hr>
                <p className=" mb-0 justify-content-left"  style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',color:'black' }}>
                Outsourcing credentialing simplifies your operations and improves financial outcomes. With deep expertise in payer requirements and industry regulations,
                
                <a
                            href="https://acerhealth.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              AcerHealth,
                        </a>  ensures faster approvals and fewer administrative errors.
                </p>
                <div class="col ml-2"  style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',color:'black' }}>
                  <p>
                   <b> Key Benefits of Our Credentialing Services:</b>
                  </p>
                  <ul class="benefits">
                    <li className=" mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>Accelerated provider enrollment and improved cash flow</li>
                    <li className=" mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>Credentialing completion with major payers within 60–90 days</li>
                    
                    <li className=" mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>Rapid response to queries and payer issues</li>
                    <li className=" mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                      	Fewer application errors that slow down enrollment
                    </li>
                    <li className=" mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                     Reduced time spent on calls, emails, and follow-ups
                    </li>
                    
                    <li className=" mb-0 justify-content-left" style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500'}}>
                      	Continuous payer compliance and eligibility status updates
                    </li>
                  </ul>
 <p className=" mb-0 justify-content-left"  style={{fontSize:'18px',fontFamily: "Alegreya Sans",fontWeight:'500',color:'black',textAlign:'justify' }}>
              When paired with our <b>medical billing outsourcing </b>and <b>revenue cycle management </b>solutions, AcerHealth provides an end-to-end
               service that supports every stage of your practice’s financial health.
                </p>

                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
}
